<div class="dialog-container" style="display: flex; flex-direction: column;">
    <mat-dialog-content>
      <app-reward-redeem-confirmation
        [data]="data"
        (onConfirm)="confirm()"
      ></app-reward-redeem-confirmation>
    </mat-dialog-content>
</div>
